<template>
  <div id="addEditDialog">
    <el-dialog
      :title="dialogName"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="600px"
      @close="closeDialog"
    >
      <el-form
        :model="formData"
        :rules="rules"
        ref="formRef"
        label-width="120px"
      >
        <el-form-item label="客户号：" prop="customerId">
          <el-select
            v-model="formData.customerId"
            placeholder="请选择客户号"
            filterable
            clearable
            @change="changeCustomer"
          >
            <el-option
              v-for="item in customerList"
              :key="item.cusNo"
              :label="item.cusNo"
              :value="item.cusNo"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="渠道号：" prop="channelId">
          <el-select
            v-model="formData.channelId"
            placeholder="请选择渠道号"
            filterable
            clearable
            @change="changeChannel"
          >
            <el-option
              v-for="item in channelList"
              :key="item.channelName"
              :label="item.channelName"
              :value="item.channelName"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目号：" prop="projectId">
          <el-select
            v-model="formData.projectId"
            placeholder="请选择项目号"
            filterable
            clearable
          >
            <el-option
              v-for="item in projectList"
              :key="item.projectName"
              :label="item.projectName"
              :value="item.projectName"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="安卓版本：" prop="androidVersion">
          <el-input
            v-model.trim="formData.androidVersion"
            placeholder="请输入安卓版本"
            :maxlength="50"
          ></el-input>
        </el-form-item>
        <el-form-item label="指定升级版本：" prop="apkVer">
          <el-input
            v-model.trim="formData.apkVer"
            placeholder="请输入指定升级版本"
            :maxlength="50"
          ></el-input>
        </el-form-item>
        <el-form-item label="目标版本：" prop="targetVersion">
          <el-input
            v-model.trim="formData.targetVersion"
            placeholder="请输入目标版本"
            :maxlength="50"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注：" prop="remarks">
          <el-input
            v-model.trim="formData.remarks"
            placeholder="请输入备注"
            type="textarea"
            :rows="3"
            :maxlength="200"
          ></el-input>
        </el-form-item>
        <el-form-item class="footBtn">
          <el-button type="primary" @click="handleSubmit">确 定</el-button>
          <el-button @click="dialogVisible = false">取 消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { getProJectList } from "@/api/ozBlockConf";

export default {
  name: "addEditDialog",
  props: {
    rowData: {
      type: Object,
      default() {
        return {};
      },
    },
    dialogName: {
      type: String,
      default() {
        return "";
      },
    },
  },
  data() {
    return {
      dialogVisible: false,
      customerList: [],
      channelList: [],
      projectList: [],
      formData: {
        customerId: "",
        channelId: "",
        projectId: "",
        androidVersion: "",
        apkVer: "",
        targetVersion: "",
        remarks: "",
        status: 1,
      },
      rules: {
        customerId: [
          { required: true, message: "请选择客户号", trigger: "change" },
        ],
        channelId: [
          { required: true, message: "请选择渠道号", trigger: "change" },
        ],
        projectId: [
          { required: true, message: "请选择项目号", trigger: "change" },
        ],
        androidVersion: [
          { required: true, message: "请输入安卓版本", trigger: "blur" },
          {
            pattern: /^\d+$/,
            message: "安卓版本必须是整数",
            trigger: "blur",
          },
        ],
        apkVer: [
          { required: true, message: "请输入指定升级版本", trigger: "blur" },
          { validator: this.validateApkVer, trigger: "blur" },
        ],
        targetVersion: [
          { required: true, message: "请输入目标版本", trigger: "blur" },
          { validator: this.validateTargetVersion, trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    // 校验指定升级版本前缀
    validateApkVer(rule, value, callback) {
      if (!value) {
        return callback();
      }
      const androidVersion = this.formData.androidVersion;
      if (androidVersion && !value.startsWith(androidVersion)) {
        return callback(
          new Error(`指定升级版本必须以安卓版本 ${androidVersion} 开头`)
        );
      }
      callback();
    },
    // 校验目标版本前缀和大小
    validateTargetVersion(rule, value, callback) {
      if (!value) {
        return callback();
      }
      const androidVersion = this.formData.androidVersion;
      const apkVer = this.formData.apkVer;
      if (androidVersion && !value.startsWith(androidVersion)) {
        return callback(
          new Error(`目标版本必须以安卓版本 ${androidVersion} 开头`)
        );
      }
      if (apkVer && this.compareVersion(value, apkVer) <= 0) {
        return callback(new Error("目标版本必须大于指定升级版本"));
      }
      callback();
    },
    // 版本号比较
    compareVersion(v1, v2) {
      const arr1 = v1.split(".").map(Number);
      const arr2 = v2.split(".").map(Number);
      const len = Math.max(arr1.length, arr2.length);
      for (let i = 0; i < len; i++) {
        const n1 = arr1[i] || 0;
        const n2 = arr2[i] || 0;
        if (n1 > n2) return 1;
        if (n1 < n2) return -1;
      }
      return 0;
    },
    async init() {
      this.dialogVisible = true;
      // 获取客户号列表
      this.customerList = await this.getListData({ type: 1 });
      this.$nextTick(() => {
        if (this.dialogName === "新增") {
          this.formData = {
            customerId: "",
            channelId: "",
            projectId: "",
            androidVersion: "",
            apkVer: "",
            targetVersion: "",
            remarks: "",
            status: 1,
          };
          this.channelList = [];
          this.projectList = [];
        } else {
          this.formData = JSON.parse(JSON.stringify(this.rowData));
          // 编辑时加载渠道号和项目号列表
          this.loadChannelAndProject();
        }
      });
    },
    async loadChannelAndProject() {
      if (this.formData.customerId) {
        this.channelList = await this.getListData({
          cusNo: this.formData.customerId,
          type: 2,
        });
      }
      if (this.formData.customerId && this.formData.channelId) {
        this.projectList = await this.getListData({
          cusNo: this.formData.customerId,
          channelName: this.formData.channelId,
          type: 3,
        });
      }
    },
    async changeCustomer(val) {
      this.formData.channelId = "";
      this.formData.projectId = "";
      this.projectList = [];
      if (val) {
        this.channelList = await this.getListData({
          cusNo: val,
          type: 2,
        });
      } else {
        this.channelList = [];
      }
    },
    async changeChannel(val) {
      this.formData.projectId = "";
      if (val && this.formData.customerId) {
        this.projectList = await this.getListData({
          cusNo: this.formData.customerId,
          channelName: val,
          type: 3,
        });
      } else {
        this.projectList = [];
      }
    },
    async getListData(params) {
      const res = await getProJectList({ page: 1, size: 3000, ...params });
      if (res.code === 0) {
        return res.data.list || [];
      }
      return [];
    },
    handleSubmit() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          const isAdd = this.dialogName === "新增";
          this.$emit("submitBtn", isAdd, this.formData);
          this.dialogVisible = false;
        }
      });
    },
    closeDialog() {
      this.$refs.formRef.resetFields();
      this.channelList = [];
      this.projectList = [];
    },
  },
};
</script>

<style scoped lang="scss">
#addEditDialog {
  .footBtn {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
  }
  ::v-deep  .el-select {
    width: 100%;
  }
}
</style>
